import {NEXT_PUBLIC_MASTER_HOST} from 'core/helpers/env';
import {REDIRECT_PARAM, REDIRECT_PARAM_VALUE} from 'core/constants';

export const withRedirectParam = (link: string) => {
    let url;
    let isHostAdded = false;
    try {
        url = new URL(link);
    } catch (e) {
        url = new URL(NEXT_PUBLIC_MASTER_HOST + link);
        isHostAdded = true;
    }

    const {searchParams} = url;
    if (!searchParams.has(REDIRECT_PARAM)) {
        searchParams.delete(REDIRECT_PARAM);
        searchParams.append(REDIRECT_PARAM, REDIRECT_PARAM_VALUE);
    }

    if (isHostAdded) {
        return url.href.split(NEXT_PUBLIC_MASTER_HOST)[1];
    }
    return url.href;
};

export const getRedirectParamValue = (link: string): typeof REDIRECT_PARAM_VALUE | null => {
    let url;
    try {
        url = new URL(link);
    } catch (e) {
        url = new URL(NEXT_PUBLIC_MASTER_HOST + link);
    }

    const searchParams = new URL(url).searchParams;

    const value = searchParams.get(REDIRECT_PARAM);
    if (value && value === REDIRECT_PARAM_VALUE) {
        return REDIRECT_PARAM_VALUE;
    }

    return null;
};
